var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-input-date__wrap"},[_c('DatePicker',{attrs:{"value":_vm.initValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"masks":_vm.masksOptions,"theme":_vm.themesOptions,"popover":_vm.popoverOptions,"is-inline":false,"input-props":{
      id: _vm.name,
      name: _vm.name,
      class: _vm.inputClass,
      autocomplete: false,
      placeholder: _vm.isIe ? '' : _vm.placeholder,
      readonly: false,
      autocomplete: 'off'
    }},on:{"input":function($event){return _vm.updateValue($event)}}}),_c('div',{staticClass:"c-input-date__icon"},[_c('IconBase',{attrs:{"view-box":"0 0 16 16","width":"16","height":"16"}},[_c('IconCalendar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }